import debug from "debug";

/**
 * Fast flow logger for debugging skip/error paths.
 * Enable via: localStorage.debug = 'desjti:checkout-v2:fastflow'
 * Note: In Chrome DevTools, enable "Verbose" log level to see these logs.
 */
export const checkoutFastFlowLogger = debug("desjti:checkout-v2:fastflow");
